(function () {
  const DEFAULT_TITLE = '5 lb';

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isSampleVariant(variant) {
    return normalize(variant.title).includes('sample');
  }

  function titleMatches(variant, preferredTitle) {
    const needle = normalize(preferredTitle);
    if (!needle) return false;
    const haystacks = [variant.title, variant.option1, variant.option2, variant.option3].map(normalize);
    return haystacks.some(function (h) {
      return h === needle || h.includes(needle);
    });
  }

  function resolvePreferredVariant(product, preferredId) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
      return null;
    }

    if (preferredId) {
      const byId = product.variants.find(function (v) {
        return v.id === Number(preferredId);
      });
      if (byId && byId.available) return byId;
    }

    const variants = product.variants;
    const firstAvailable = variants.find(function (v) {
      return v.available;
    });

    const nonSample = variants.find(function (v) {
      return v.available && !isSampleVariant(v);
    });

    const fiveLb = variants.find(function (v) {
      return v.available && titleMatches(v, DEFAULT_TITLE);
    });

    return fiveLb || nonSample || firstAvailable || product.selected_or_first_available_variant || variants[0];
  }

  function readPreferredIdFromDom(root) {
    if (!root) return null;
    const jsonNode = root.querySelector('[data-rhh-preferred-variant-id]');
    if (jsonNode && jsonNode.textContent) {
      const parsed = Number(JSON.parse(jsonNode.textContent));
      if (parsed) return parsed;
    }
    const attr = root.dataset && root.dataset.rhhPreferredVariantId;
    if (attr) return Number(attr);
    return null;
  }

  window.RHHPreferredVariant = {
    DEFAULT_TITLE: DEFAULT_TITLE,
    resolvePreferredVariant: resolvePreferredVariant,
    readPreferredIdFromDom: readPreferredIdFromDom,
  };
})();
